<nav class="navbar">
  <div class="container-fluid">
    <a class="navbar-brand d-flex justify-content-start align-items-start flex-column" href="#">
      <img ngSrc="logo.svg" alt="Hellpository Kft" width="100" height="100" class="d-inline-block align-text-top">
      <img ngSrc="logo_b.png" alt="Hellpository Kft" width="352" height="100" class="mt-3 d-inline-block align-text-top">
      <img ngSrc="logo_c.png" alt="Hellpository Kft" width="352" height="100" class="mt-3 d-inline-block align-text-top">
    </a>
  </div>
</nav>
